import Content from './Content'
import clsx from 'clsx'

export default function Message({ children, className = '' }: { children: React.ReactNode; className?: string }) {
  return <Content className={clsx(className, 'content title font-light')}>{children}</Content>
}
